import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Row, Col, Table } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import moment from 'moment';
import { deleterDispatchHelper } from 'actions/DeleterActions';
import { getDefaultImage, getThumbFile } from 'helpers/items';
import { getNameInCurrentLanguage } from 'helpers/intl';
import { parseQs } from 'helpers/http';
import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';
import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';
import List from 'components/List';
import ListFilterCurrency from 'components/layout/list/filters/ListFilterCurrency';
import ListFilterItemActive from 'components/layout/list/filters/ListFilterItemActive';
import ListFilterReset from 'components/layout/list/ListFilterReset';
import ItemNew from 'components/modals/ItemNew';
import { ROLE_ERP_MASTER } from 'js/constants';
import may from 'js/security';
import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';
import _, { forEach as _forEach } from 'lodash';
import Button from 'react-bootstrap/lib/Button';
import { copyItem } from 'actions/ItemActions';
import { getCategoriesSettingsR } from 'actions/TemplateSettingsActions';
import ListFilterCategory from 'components/layout/list/filters/ListFilterCategory';
import ListFilterCompany from 'components/layout/list/filters/ListFilterCompany';

class Items extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
    };
  }

  componentDidMount = () => {
    if (
      this.props.categoriesSettings?.list === undefined ||
      (this.props.listCategories?.data?.list?.length > 0 &&
        _.isEqual(this.props.categoriesSettings?.list, this.props.listCategories?.data?.list) === false)
    ) {
      this.props.getCategoriesSettingsR();
    }
  };

  componentDidUpdate = prevProps => {
    const {
      appIntl: { urlPrefix },
      history,
    } = this.props;

    if (prevProps.pendingCopyItem !== this.props.pendingCopyItem && this.props.pendingCopyItem === false) {
      history.push(urlPrefix + 'account/items/' + this.props.copiedItemId);
    }
  };

  // change the url to display item information
  handleRowClick = detailsUrl => {
    this.props.history.push(detailsUrl);
  };

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }, { link: null, name: messages.products }]}
        className="p-t-0"
      />
    );
  };

  handleRemoveClick = (e, itemId) => {
    e.preventDefault();
    e.stopPropagation();

    const { deleteItem } = this.props;
    deleteItem(itemId);
  };

  getUrlData = () => {
    const { location } = this.props;
    const query = parseQs(location.search);

    const urlData = {
      filters: {
        // type: 'item',
        target: query.target,
        isActive: query.isActive,
        CURRENCY: query.currency,
        category: query.category,
      },
    };

    return urlData;
  };

  copyProduct = item => {
    this.props.copyItem(item);
  };

  getCategoryPathName = item => {
    const { appIntl, categoriesSettings } = this.props;
    let categoryName = '';
    if (typeof item.category_path !== 'undefined' && typeof item.category_path === 'string') {
      const path = item.category_path.split(',');
      _forEach(path, singlePath => {
        if (singlePath !== '' && singlePath !== '0') {
          const index = _.findIndex(categoriesSettings?.list, category => category.id === singlePath);
          if (index !== -1) {
            categoryName =
              categoryName + getNameInCurrentLanguage(categoriesSettings?.list[index].name, appIntl) + ' > ';
          }
        }
      });
    }
    return categoryName;
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
      user,
    } = this.props;

    const currentLocaleData = moment.localeData();

    const filters = [];
    filters.push(<ListFilterCompany key="target" />);
    filters.push(<ListFilterCurrency key="currency" />);
    filters.push(<ListFilterItemActive key="is-active" />);
    filters.push(
      <ListFilterCategory key="category" appIntl={appIntl} categoriesSettings={this.props.categoriesSettings} />
    );
    filters.push(<ListFilterReset key="reset-all" availableFilters={['target', 'currency', 'isActive', 'category']} />);

    const columns = [
      messages.image,
      <i className="fa fa-eye" />,
      messages.item,
      messages.category,
      messages.attributes,
      messages.prices,
      messages.actions,
    ];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const item = list.data.list[i];
      const { id, name, is_active: isActive, category, attributes, pricing, is_resource: isResource } = list.data.list[
        i
      ];
      const detailsUrl = `${appIntl.urlPrefix}account/items/${id}`;

      const defaultImage = getDefaultImage(item);
      let defaultImageThumb;
      if (defaultImage !== undefined) {
        defaultImageThumb = getThumbFile(defaultImage);
      }
      tBody.push(
        <tr key={i} className="clickable">
          <td className="v-align-middle">
            {defaultImageThumb !== undefined && (
              <img src={defaultImageThumb.web_link} style={{ width: '100px' }} alt={name} />
            )}
          </td>
          <td className="v-align-middle">
            <i className={'fa fa-eye' + (isActive ? '' : '-slash')} />
          </td>
          <td className="v-align-middle">
            {typeof name === 'object' ? getNameInCurrentLanguage(name, appIntl) : name}
          </td>
          <td className="v-align-middle">
            {!!category && (
              <>
                <IntlFormInlineSelector /> <p className="categoryPathName">{this.getCategoryPathName(item)}</p>{' '}
                {getNameInCurrentLanguage(category.name, appIntl)}
              </>
            )}
          </td>
          <td className="v-align-middle">
            {!!attributes && (
              <ul>
                {attributes.map(attribute => {
                  let index = _.findIndex(attribute?.values?.[0]?.value, value => value?.lang === appIntl.locale);
                  if (index === -1) {
                    index = _.findIndex(attribute?.name, name => name?.lang === appIntl.locale);
                  }
                  if (
                    attribute?.values[0]?.value &&
                    attribute?.values[0]?.value[index] &&
                    attribute?.values[0]?.value[index]?.name &&
                    attribute?.values[0]?.value[index]?.name !== '0'
                  ) {
                    return (
                      <li key={attribute?.name}>
                        {getNameInCurrentLanguage(attribute.name, appIntl) +
                          ': ' +
                          getNameInCurrentLanguage(attribute.values[0].value, appIntl)}
                      </li>
                    );
                  }
                  return <li key={attribute?.name} />;
                })}
              </ul>
            )}
          </td>
          <td className="v-align-middle">
            <Row>
              <Col xs={12} md={isResource ? 6 : 12}>
                {!!pricing.pseudo_price && (
                  <span className="hint-text">
                    <del>
                      <FormattedNumber value={pricing.pseudo_price} style="currency" currency={pricing.currency} />
                    </del>
                    <br />
                  </span>
                )}

                {pricing.price ? (
                  <FormattedNumber value={pricing.price} style="currency" currency={pricing.currency} />
                ) : (
                  '-'
                )}
              </Col>
              {isResource && (
                <Col xs={12} md={6}>
                  <i className="fa fa-calendar" /> {messages.rent_price}
                  <br />
                  {currentLocaleData._weekdaysMin[1] + ' - ' + currentLocaleData._weekdaysMin[5]}{' '}
                  {pricing.weekday_price ? (
                    <FormattedNumber value={pricing.weekday_price} style="currency" currency={pricing.currency} />
                  ) : (
                    '-'
                  )}
                  <br />
                  {currentLocaleData._weekdaysMin[6] + ', ' + currentLocaleData._weekdaysMin[0]}{' '}
                  {pricing.weekend_price ? (
                    <FormattedNumber value={pricing.weekend_price} style="currency" currency={pricing.currency} />
                  ) : (
                    '-'
                  )}
                </Col>
              )}
            </Row>
          </td>
          <td className="v-align-middle text-right itemActions">
           <Button
              bsSize="sm"
              bsStyle="success"
              className="btn-rounded"
              onClick={() => {
                this.copyProduct(item);
              }}
            >
              <i className="fas fa-copy" /> {messages.copy}
            </Button>
            <Link to={detailsUrl} className="btn-rounded btn btn-sm btn-default">
              <i className="fa fa-pencil-alt" /> {messages.edit}
            </Link>
            {may(ROLE_ERP_MASTER, user.roles) && (
              <SimplePrompt
                onSuccess={e => {
                  this.handleRemoveClick(e, id);
                }}
              />
            )}
          </td>
        </tr>
      );
    }

    const resultTable =
      list.pending || this.props.pendingCopyItem || this.props.pendingCategoriesSettings ? (
        <Loader />
      ) : (
        <Table responsive hover>
          <thead>
            <tr>
              {columns.map((column, i) => {
                return (
                  <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                    {column}
                  </th>
                );
              })}
            </tr>
          </thead>
          <ReactCSSTransitionGroup
            transitionName="tablerows"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={1}
            component="tbody"
          >
            {tBody}
          </ReactCSSTransitionGroup>
        </Table>
      );

    return (
      <DocMeta tags={generateMetaTags(messages.meta.items)}>
        <List
          listName="items"
          url="/api/items.json"
          urlData={this.getUrlData()}
          list={list}
          title={messages.products}
          iconClass="fa fa-cube"
          showNew
          newText={messages.add_product}
          newAction={this.showNew}
          showSearch
          sortOptions={['relevance,desc', 'cdate,desc', 'mdate,desc', 'name,asc']}
          breadcrumb={this.getBreadcrumb()}
          metaIdentifier="Items:Item"
          filters={filters}
        >
          {resultTable}

          <div id="item-new">
            <ItemNew show={this.state.showNew} close={this.closeNew} />
          </div>
        </List>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.items,
    user: state.login.user,
    pendingCopyItem: state.list.items.pendingCopyItem,
    copiedItemId: state.list.items.copiedItemId,
    categoriesSettings: state.templateSettings.categoriesSettings,
    pendingCategoriesSettings: state.templateSettings.pendingCategoriesSettings,
    listCategories: state.list.categories,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteItem: itemId => {
      deleterDispatchHelper('item', '/api/items/' + itemId + '.json', dispatch);
    },
    copyItem: data => {
      dispatch(copyItem(data));
    },
    getCategoriesSettingsR: () => {
      dispatch(getCategoriesSettingsR());
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Items)
  )
);
